import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import Seo from "../../../components/_UI/seo";
import CabinetLogo from "../../../components/_UI/cabinetLogo";
import LangSwitcher from "../../../components/_UI/langSwitcher";
import {requestEarlyAccess} from "../../../store/cabinet/action";
import {logout} from "../../../store/main/action";
import {EARLY_ACCESS, isEarlyAccessGranted, isEarlyAccessPending} from "../../../helpers/user";

// Почта для обратной связи — из текста альфа-теста
const FEEDBACK_EMAIL = 'official@timecapsules.xyz';

// ---------------------------------------------------------------------------
// Пока у пользователя нет доступа к альфа-тесту (early_access_status !== granted),
// кабинет закрыт целиком: вместо него эта страница. Из неё можно подать заявку
// или выйти — иначе человек оказался бы заперт
// ---------------------------------------------------------------------------

const CabinetEarlyAccessPage = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const userData = useSelector(store => store.cabinet.userData);
    const started = useSelector(store => store.cabinet.earlyAccessStarted);
    const err = useSelector(store => store.cabinet.earlyAccessErr);
    const logoutStatusStarted = useSelector(store => store.cabinet.logoutStatusStarted);

    const status = userData?.user?.early_access_status;
    const isPending = isEarlyAccessPending(status);
    const isGranted = isEarlyAccessGranted(status);

    // статус заявки показываем плашкой: серая — не подана, жёлтая — на
    // рассмотрении, зелёная — одобрена
    const statusView = () => {
        if (isGranted){
            return {name: t('Доступ открыт'), style: Styles.statusChipOk};
        }
        if (isPending){
            return {name: t('Заявка на рассмотрении'), style: Styles.statusChipWait};
        }
        if (status === EARLY_ACCESS.none || !status){
            return {name: t('Заявка не подана'), style: Styles.statusChipOff};
        }
        return {name: status, style: Styles.statusChipOff};
    };

    const statusItem = statusView();

    const sendHandler = () =>{
        if (started || isPending){
            return;
        }
        dispatch(requestEarlyAccess());
    };

    const errorText = err?.errors
        ? Object.values(err.errors).flat()[0]
        : (err?.message || '');

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Alpha Test Time Capsule')}/>

            <div className={`${Styles.topWrap}`}>
                <div className={`${Styles.logoWrap}`}>
                    <CabinetLogo/>
                </div>
                <div className={`${Styles.topOther}`}>
                    <LangSwitcher isCabinet={true}/>
                    <div
                        className={`${Styles.logOutBtn}`}
                        onClick={()=>{
                            if (!logoutStatusStarted){
                                dispatch(logout());
                            }
                        }}
                    >
                        {t('Выйти')}
                    </div>
                </div>
            </div>

            <div className={`${Styles.posWrap}`}>
                <div className={`${Styles.cardWrap}`}>
                    <div className={`${Styles.cardHead}`}>
                        <div className={`${Styles.cardTitle}`}>
                            {t('Добро пожаловать в Alpha Test Time Capsule!')}
                        </div>
                        <div className={`${Styles.statusChip} ${statusItem.style}`}>
                            <span className={`${Styles.statusDot}`}/>
                            {statusItem.name}
                        </div>
                    </div>

                    {isPending ? (
                        <>
                            <div className={`${Styles.doneWrap}`}>
                                <span className={`${Styles.doneMark}`}>✓</span>
                                <span className={`${Styles.doneTitle}`}>
                                    {t('Благодарим за подачу заявки!')}
                                </span>
                            </div>

                            <div className={`${Styles.cardText}`}>
                                {t('Мы сообщим, когда доступ к тестированию будет открыт.')}
                            </div>
                        </>
                    ) : (
                        <div className={`${Styles.cardText}`}>
                            {t('Вы можете подать заявку на участие в Alpha Test и одними из первых познакомиться с ключевыми функциями платформы. Для участия подайте заявку ниже. После подтверждения вы получите доступ к тестированию продукта.')}
                        </div>
                    )}

                    <div className={`${Styles.cardText}`}>
                        {t('Если в ходе тестирования у вас появятся идеи, предложения или комментарии по улучшению платформы, пожалуйста, отправляйте их на нашу официальную почту')}:{' '}
                        <a className={`${Styles.cardLink}`} href={`mailto:${FEEDBACK_EMAIL}`}>{FEEDBACK_EMAIL}</a>
                    </div>

                    <div className={`${Styles.cardText}`}>
                        {t('Ваше участие и обратная связь помогут нам улучшить Time Capsule перед следующими этапами развития.')}
                    </div>

                    {errorText ? (
                        <div className={`${Styles.cardErr}`}>{errorText}</div>
                    ) : null}

                    {!isPending ? (
                        <div
                            className={`${Styles.cardBtn} ${started ? Styles.cardBtnDsb : ''}`}
                            onClick={sendHandler}
                        >
                            {started ? t('Отправляем…') : t('Подать заявку')}
                        </div>
                    ) : null}
                </div>
            </div>
        </section>
    );
};

export default CabinetEarlyAccessPage;
